import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import { normalizeAuthUser } from '@xver/store/auth/normalizeAuthUser';

export const ME_QUERY_KEY = ['apis.v1.users.me'];

export function useMeQuery() {
    return useQuery({
        queryKey: ME_QUERY_KEY,
        // ProfilePage/SecurityPage/BillingsPage read this result in preference to the redux
        // store, so it needs the same backfill the auth reducer applies.
        queryFn: async () => normalizeAuthUser(await Endpoints.v1.Users.getMe()),
        staleTime: 0,
        refetchOnMount: 'always',
        refetchOnWindowFocus: 'always',
    });
}
